import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import type { LearningLanguage, Locale } from '../model/types';

interface LanguageFlagProps {
  /** Изучаемый язык или язык интерфейса (`ru` есть только у второго). */
  language: LearningLanguage | Locale;
  className?: string;
}

/**
 * Флаг изучаемого языка — SVG, а не эмодзи: в Windows (и в Telegram Desktop
 * под ней) эмодзи флагов рисуются двумя буквами «GB», а не флагом.
 * Упрощённые, под размер иконки в строке текста: мелкие детали на 20 px всё
 * равно не видны.
 */
export function LanguageFlag({ language, className }: LanguageFlagProps) {
  return (
    <svg
      viewBox="0 0 30 20"
      aria-hidden="true"
      className={cn('h-[0.8em] w-[1.2em] shrink-0 overflow-hidden rounded-[3px] shadow-[0_0_0_1px_rgba(0,0,0,0.08)]', className)}
    >
      {FLAGS[language]}
    </svg>
  );
}

const FLAGS: Record<LearningLanguage | Locale, ReactNode> = {
  en: (
    <>
      <rect width="30" height="20" fill="#012169" />
      <path d="M0 0l30 20M30 0L0 20" stroke="#fff" strokeWidth="4" />
      <path d="M0 0l30 20M30 0L0 20" stroke="#C8102E" strokeWidth="1.6" />
      <path d="M15 0v20M0 10h30" stroke="#fff" strokeWidth="6" />
      <path d="M15 0v20M0 10h30" stroke="#C8102E" strokeWidth="3.4" />
    </>
  ),
  de: (
    <>
      <rect width="30" height="6.67" fill="#000" />
      <rect y="6.67" width="30" height="6.67" fill="#DD0000" />
      <rect y="13.33" width="30" height="6.67" fill="#FFCE00" />
    </>
  ),
  pt: (
    <>
      <rect width="30" height="20" fill="#DA291C" />
      <rect width="12" height="20" fill="#046A38" />
      <circle cx="12" cy="10" r="4.2" fill="#FFCC00" />
    </>
  ),
  fr: (
    <>
      <rect width="10" height="20" fill="#002395" />
      <rect x="10" width="10" height="20" fill="#fff" />
      <rect x="20" width="10" height="20" fill="#ED2939" />
    </>
  ),
  es: (
    <>
      <rect width="30" height="20" fill="#AA151B" />
      <rect y="5" width="30" height="10" fill="#F1BF00" />
    </>
  ),
  ru: (
    <>
      <rect width="30" height="6.67" fill="#fff" />
      <rect y="6.67" width="30" height="6.67" fill="#0039A6" />
      <rect y="13.33" width="30" height="6.67" fill="#D52B1E" />
    </>
  ),
};
